<script setup lang="ts">
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { AgentChatFeedbackAbilitySubject } from '@/@vxapp/AiAgents/chatFeedbackContract'
import AiFeedbackPage from '@/components/AiWorkspace/Feedback/AiFeedbackPage.vue'

setPageTitle('Response feedback')

// The AI workspace layout, gated by the feedback read permission rather than chat access.
definePage({
  meta: {
    subject: AgentChatFeedbackAbilitySubject.AI_FEEDBACK,
    layout: PageMeta.AiWorkspace.Chat.Meta.layout,
  },
})
</script>

<template>
  <AiFeedbackPage />
</template>
